import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

/**
 * Loading placeholder row for {@link ProjectsTable}.
 *
 * Each cell's placeholder mirrors the SHAPE of the real cell it stands in for
 * so the skeleton reads as a table rather than a block of grey bars — notably
 * the circular owner avatar and the rounded-full type pill. Column
 * order/widths match the header in `ProjectsTable`.
 *
 * The `<tr>` shell and its `data-testid="projects-table-skeleton-row"` come
 * from `TableSkeletonRow` via the `testId` override, so existing test queries
 * keep resolving; the trailing 12-wide actions cell comes from
 * `TableSkeletonActionsCell`.
 */
export const ProjectsTableSkeletonRow = () => (
  <TableSkeletonRow testId="projects-table-skeleton-row">
    {/* Name */}
    <DatatableCell>
      <Skeleton data-testid="skeleton-loader" className="h-4 w-40" />
    </DatatableCell>

    {/* Folders */}
    <DatatableCell>
      <Skeleton data-testid="skeleton-loader" className="h-4 w-8" />
    </DatatableCell>

    {/* Type — rounded-full status pill */}
    <DatatableCell>
      <Skeleton data-testid="skeleton-loader" className="h-6 w-24 rounded-full" />
    </DatatableCell>

    {/* Owner — circular avatar + name */}
    <DatatableCell>
      <div className="flex items-center gap-2">
        <Skeleton data-testid="skeleton-loader" className="size-6 rounded-full" />
        <Skeleton data-testid="skeleton-loader" className="h-4 w-24" />
      </div>
    </DatatableCell>

    {/* Last activity */}
    <DatatableCell>
      <Skeleton data-testid="skeleton-loader" className="h-4 w-20" />
    </DatatableCell>

    {/* Created */}
    <DatatableCell>
      <Skeleton data-testid="skeleton-loader" className="h-4 w-16" />
    </DatatableCell>

    {/* Actions */}
    <TableSkeletonActionsCell />
  </TableSkeletonRow>
);

ProjectsTableSkeletonRow.displayName = 'ProjectsTableSkeletonRow';
